declare global {
  interface Window {
    // biome-ignore lint/suspicious/noExplicitAny: GA4 dataLayer requires loose typing
    dataLayer: any[];
    // biome-ignore lint/suspicious/noExplicitAny: GA4 gtag requires loose typing
    gtag: (...args: any[]) => void;
  }
}

export function initGA() {
  const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;
  if (!measurementId) return;

  // Dynamically load the gtag.js script — avoids unsafe-inline in CSP
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId, {
    send_page_view: false, // tracked manually via trackPageView()
    anonymize_ip: true,
  });
}

export function trackPageView(path: string, title?: string) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title ?? document.title,
  });
}

export function trackEvent(
  name: string,
  params?: Record<string, string | number | boolean>
) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
}
